import { PositionType } from 'data/types';

type EdgeStyleInput = {
  isExterior: boolean;
  isSelected: boolean;
};

const SELECTED_COLOR = '#3b82f6';
const EXTERIOR_COLOR = '#111111';
const INTERIOR_COLOR = '#9ca3af';

export const SPACE_POLYGON_WALLS_HINT =
  'Click on an exterior wall to view/edit it';

export const SPACE_POLYGON_WALLS_HINT_WIDTH = 180;
export const SPACE_POLYGON_WALLS_HINT_HEIGHT = 48;
export const WALL_HIT_STROKE = 18;

export function getEdgeStrokeColor({
  isExterior,
  isSelected
}: EdgeStyleInput): string {
  if (!isExterior) {
    return INTERIOR_COLOR;
  }
  if (isSelected) {
    return SELECTED_COLOR;
  }
  return EXTERIOR_COLOR;
}

type EdgeStrokeWidthInput = EdgeStyleInput & {
  selectedStroke: number;
  exteriorStroke: number;
  interiorStroke: number;
};

export function getEdgeStrokeWidth({
  isExterior,
  isSelected,
  selectedStroke,
  exteriorStroke,
  interiorStroke
}: EdgeStrokeWidthInput): number {
  if (!isExterior) {
    return interiorStroke;
  }
  if (isSelected) {
    return selectedStroke;
  }
  return exteriorStroke;
}

export function polygonCentroid(vertices: PositionType[]): PositionType | null {
  if (vertices.length < 3) {
    return null;
  }

  let area2 = 0;
  let cx = 0;
  let cy = 0;
  vertices.forEach((vertex, i) => {
    const next = vertices[(i + 1) % vertices.length];
    const cross = vertex.x * next.y - next.x * vertex.y;
    area2 += cross;
    cx += (vertex.x + next.x) * cross;
    cy += (vertex.y + next.y) * cross;
  });

  if (area2 === 0) {
    return null;
  }

  return { x: cx / (3 * area2), y: cy / (3 * area2) };
}

export function spaceDiagramHintBox(centroid: PositionType): {
  x: number;
  y: number;
  width: number;
  height: number;
} {
  return {
    x: centroid.x - SPACE_POLYGON_WALLS_HINT_WIDTH / 2,
    y: centroid.y - SPACE_POLYGON_WALLS_HINT_HEIGHT / 2,
    width: SPACE_POLYGON_WALLS_HINT_WIDTH,
    height: SPACE_POLYGON_WALLS_HINT_HEIGHT
  };
}
